import { gql } from '@apollo/client';

export const FETCH_DOCU_SIGN_ENVELOPES = gql`
  query Flex_FetchDocuSignEnvelopes($returnUrl: String!, $userId: Int!) {
    user(id: $userId) {
      id
      docuSignEnvelopes(returnUrl: $returnUrl) {
        id
        status
        url
      }
    }
  }
`;
